import { createFileRoute } from '@tanstack/react-router';
import { ContactUs } from '@/features/consumer/contact-us';

export const Route = createFileRoute('/(consumer)/_public/contact-us')({
  component: ContactUs,
});
